export default __webpack_public_path__ + "static/media/smilies02.53d49c70.png";